import { Product } from "../types/Product";
import { ServerResponse } from "../types/ServerResponse";
import NetworkUtil from "./NetworkUtil"

export default class ShopAPI {

    //Products
    public static async getProducts():Promise<{success:boolean,reason?:string,data:any[]}>{
        return NetworkUtil.makeGet("/api/admin/shop/getProducts");
    }

    public static async getHomeKitProducts():Promise<{success:boolean,reason?:string,data:any[]}>{
        return NetworkUtil.makeGet("/api/admin/shop/getHomeKitProducts");
    }

    public static async filterProducts(filter):Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makePost("/api/admin/shop/productsFilter", filter)
    }

    public static async createProduct(product:Product):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/shop/createProduct", product)
    }
    
    public static async editProduct(product):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/shop/editProduct", product)
    }

    //Shop
    public static async orderSubmitted(paymentInfo):Promise<ServerResponse>{
        return await NetworkUtil.makePost("/api/admin/shop/orderSubmitted", {paymentInfo: paymentInfo})
    }

    public static async getSalesTax(address):Promise<ServerResponse>{
        return await NetworkUtil.makePost("/api/admin/shop/getSalesTax", {address: address})
    }

    //Orders
    public static async getOrders():Promise<{success:boolean,reason?:string,data:any[]}>{
        return NetworkUtil.makeGet("/api/admin/shop/getOrders");
    }

    public static async filterOrders(filter):Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makePost("/api/admin/shop/filterOrders", filter)
    }

    public static async getReciptInOrderHistory(transID, productMap):Promise<any>{
        return NetworkUtil.makePostForBlob("/api/admin/shop/getReciptInOrderHistory", {transactionID: transID, productMap: productMap})
    }



}